import { visitaService } from '../_services/';
import alerts from '../_components/alerts';
import { history } from '../_utils'
import Swal from 'sweetalert2'; 

export const visitaAction = {
    getVisita,
    getVisitaById,
    onChangeProps,
    editVisitaInfo,
    createVisita,
    createVisitaFrizzo,
    deleteVisitaById,
    clear
};
function getVisita(showWaiting, page = 1, limit = 10, term = "") {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }

        let apiEndpoint = `visitas?page=${page}&limit=${limit}`;
        if (term) {
            apiEndpoint += `&term=${encodeURIComponent(term)}`;
        }

        visitaService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeVisitasList(response.data.Items, response.data.TotalItems));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createVisita(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'visitas/';
        visitaService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    //verifica se tem link no retorno. Se tiver, abre direto em nova aba, mas o link não pode ser excel. 
                    if (ret.message.includes('https') && !ret.message.trim().toLowerCase().endsWith('.csv')) {
                        //history.push(window.open(ret.message))
                        window.open(ret.message, '_blank'); // Abre o link em uma nova aba
                    }
                    else {
                        alerts.success(ret.message, '/visitas'); //ret.path
                    }
                } else {
                    alerts.warning(response.data.Message);
                }
                //dispatch(createUserInfo());
                //history.push('/visitas');
            })
    }
}

function createVisitaFrizzo(payload, animais_lactacao, producao_dia, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'VisitasFrizzo/';

        // Criando um FormData a partir do payload com o nome 'visita'
        let formData = new FormData();

        // Envolvendo o payload dentro de 'visita'
        formData.append('visita', JSON.stringify(payload));
        formData.append('animais_lactacao', animais_lactacao);
        formData.append('producao_dia', producao_dia);

        // Enviando o FormData
        visitaService.post(apiEndpoint, formData)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    // Verifica se tem link no retorno. Se tiver, abre direto em nova aba
                    if (ret.message.includes('https')) {
                        window.open(ret.message, '_blank'); // Abre o link em uma nova aba
                    } else {
                        alerts.success(ret.message, '/visitas'); // Exibe mensagem de sucesso e redireciona
                    }
                } else {
                    alerts.warning(response.data.Message);
                }
            })
            .catch(error => {
                alerts.error('Erro ao enviar dados.');
            });
    };
}

function getVisitaById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'visitas/' + id;
        visitaService.get(apiEndpoint)
            .then((response) => {
                dispatch(editVisitasDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}
function editVisitaInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'visitas/' + id;
        visitaService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    alerts.success(ret.message, '/visitas'); //ret.path
                } else {
                    alerts.warning(response.request.responseText);
                }
                if (showWaiting) {
                    alerts.clean();
                }
                //dispatch(updatedUserInfo());
                //history.push('/visitas');
            })
    }
}
function deleteVisitaById(id) {
    return (dispatch) => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir a visita?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não, cancelar!',
            dangerMode: true,
            heightAuto: false
        }).then((result) => {
            if (result.isConfirmed) {
                alerts.waiting();

                visitaService.deleteDetail(`visitas/${id}`)
                    .then((response) => {
                        if (response.status === 200) {
                            const ret = response.data;
                            dispatch(deleteVisitasDetails());
                            dispatch(visitaAction.getVisita());
                            alerts.clean();
                            alerts.success(ret.message);
                        } else {
                            alerts.warning(response.data);
                        }
                    })
                    .catch((err) => {
                        console.error('Erro ao excluir visita:', err);
                        alerts.error('Erro ao excluir visita. Tente novamente.');
                    });
            }
        });
    };
}
export function changeVisitasList(visita, totalItems) {
    return {
        type: "FETECHED_ALL_VISITA",
        visita: visita,
        totalItems: totalItems
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editVisitasDetails(visita) {
    return {
        type: "VISITA_DETAIL",
        id: visita.id,
        id_fazenda: visita.id_fazenda,
        data: visita.data,
        tipo_relatorio: visita.tipo_relatorio,
        arquivo: visita.arquivo,
        obs: visita.obs,
        data_cadastro: visita.data_cadastro,
        usuario_cadastro: visita.usuario_cadastro,
        data_exclusao: visita.data_exclusao,
        usuario_exclusao: visita.usuario_exclusao,
        fazenda: visita.fazenda
    }
}
export function updatedUserInfo() {
    return {
        type: "VISITA_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "VISITA_CREATED_SUCCESSFULLY"
    }
}
export function deleteVisitasDetails() {
    return {
        type: "DELETED_VISITA_DETAILS"
    }
}

export function clear() {
    return {
        type: "VISITA_CLEAR"
    };
}